module.exports = __webpack_public_path__ + "img/4_101.60a3f132.png";